/**
 * Sort function for items with a label property
 * @param a First item to compare
 * @param b Second item to compare
 * @returns Negative if a comes before b, positive if b comes before a, 0 if equal
 */
export function sortByLabel<T extends { label: string }>(a: T, b: T): number {
	return a.label.localeCompare(b.label);
}
